import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const ocpSubKey = localStorage.getItem('ocpSubKey') || '';
    req = req.clone({
        headers: req.headers.append('Ocp-Apim-Subscription-Key', ocpSubKey),
    });

    return next(req).pipe(
        catchError((error: unknown) => {
            return throwError(() => error);
        })
    );
}
